import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import useCustomValidation from "../validationSchema";
import { getBusinessCategory, editBusinessCategory } from "../../../api/businessCategory";

const EditBusinessCategory = () => {
    const { t } = useTranslation();
    const { addBusinessCategorySchema } = useCustomValidation();
    const navigate = useNavigate();
    const { id } = useParams();

    const [businessCategoryData, setBusinessCategoryData] = useState(null);

    const { setData, loading, error, success } = useResponse(editBusinessCategory, () => {
        navigate("/business-categories");
    });

    useEffect(() => {
        const fetchBusinessCategory = async () => {
            try {
                const res = await getBusinessCategory(id);
                const data = res?.data;
                setBusinessCategoryData({
                    name: data.name || "",
                    description: data.description || "",
                });
            } catch (err) {
                console.error("Failed to fetch business category data", err);
            }
        };

        fetchBusinessCategory();
    }, [id]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: businessCategoryData || {
            name: "",
            description: "",
        },
        validationSchema: addBusinessCategorySchema,
        onSubmit: (values) => {
            const updatedData = {
                name: values.name,
            };
            setData({ id, data: updatedData, type: "edit" });
        },
    });

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs title={`${t("btns.Edit")} ${t("Business Category")}`} />

                <Form
                    className="needs-validation"
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                    }}
                >
                    <Row>
                        {/* Name Field */}
                        <Col md="6">
                            <FormGroup className="mb-3">
                                <Label>{t("Name")}</Label>
                                <Input
                                    name="name"
                                    placeholder={t("Name")}
                                    type="text"
                                    onChange={validation.handleChange}
                                    value={validation.values.name}
                                    invalid={!!(validation.touched.name && validation.errors.name)}
                                />
                                <FormFeedback>{validation.errors.name}</FormFeedback>
                            </FormGroup>
                        </Col>

                        {/* Description Field (optional) */}
                        {/* <Col md="6">
                            <FormGroup className="mb-3">
                                <Label>{t("Description")}</Label>
                                <Input
                                    name="description"
                                    placeholder={t("Description")}
                                    type="text"
                                    onChange={validation.handleChange}
                                    value={validation.values.description}
                                    invalid={!!(validation.touched.description && validation.errors.description)}
                                />
                                <FormFeedback>{validation.errors.description}</FormFeedback>
                            </FormGroup>
                        </Col> */}
                    </Row>

                    <FormButtonHandler btnTxt={t("Update")} loading={loading} />

                    <ResultHandler
                        error={error}
                        success={success}
                        successMsg={t("Updated Successfully!")}
                    />
                </Form>
            </Container>
        </div>
    );
};

export default EditBusinessCategory;
